// window._ = require("lodash");
/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */
// import Echo from 'laravel-echo';
// window.Pusher = require('pusher-js');
// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: import.meta.env.VITE_PUSHER_APP_KEY,
//     cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
import Referral from "./Referral";
import Favorite from "./Favorite";
import GoogleMap from "./GoogleMap";
import SearchLocationAutocomplete from "./SearchLocationAutocomplete";
import Share from "./Share";
import Splide from "@splidejs/splide";
import "./FormValidation";
import UTM from "./Utm";
import Experiment from "./Experiment";


window.referralCode = new Referral("codigo_referido");
window.fbclid = new Referral("fbclid");
window.gclid = new Referral("gclid");
window.favorites = new Favorite("unit");
window.onload = () => {
    referralCode.setValue();
    fbclid.setValue();
    gclid.setValue();
    utm.setValue();
};

window.GoogleMap = new GoogleMap(import.meta.env.VITE_GMAP_API);
window.AssetAutocomplete = new SearchLocationAutocomplete()
window.Share = new Share();
window.utm = new UTM("utm");
window.experiment = new Experiment("cta_experiment");

window.initSplideHome = function() {
    new Splide("#splide-communities", {
        width: "100%",
        height: "309px",
        arrows: false,
        pagination: false,
        breakpoints: {
            640: {
                perPage: 1,
                destroy: false,
                pagination: true,
            },
            1024: {
                pagination: true,
            },
        },
        classes: {
            prev: "splide__arrow--prev",
            next: "splide__arrow--next",
            pagination: "splide__pagination splide-btnspag-communities",
        },
    }).mount();

    new Splide("#splide-commune", {
        width: "100%",
        arrows: false,
        pagination: false,
        perPage: 4,
        destroy: true,
        breakpoints: {
            640: {
                perPage: 1,
                fixedWidth: "80%",
                destroy: false,
            },
            1024: {
                perPage: 3,
                fixedWidth: "40%",
                destroy: false,
            },
            1280: {
                perPage: 4,
                destroy: true,
            },
        },
    }).mount();
};

window.initOutstandingSplide = function() {
    new Splide("#splide-outstanding", {
        width: "100%",
        height: "27rem",
        arrows: false,
        pagination: false,
        perPage: 4,
        gap: "1.5em",
        destroy: true,
        breakpoints: {
            640: {
                perPage: 1,
                fixedWidth: "80%",
                destroy: false,
                arrows: false,
            },
            1187: {
                perPage: 3,
                fixedWidth: "40%",
                destroy: false,
            },
            1280: {
                perPage: 4,
                destroy: true,
            },
        },
        classes: {
            arrows: "splide__arrows arrows-building-ext",
            arrow: "splide__arrow arrow-building-ext",
            prev: "splide__arrow--prev arrow-prev-building-ext",
            next: "splide__arrow--next arrow-next-building-ext",
        },
    }).mount();
};

window.initDateSplide = function() {
    new Splide("#splide-date", {
        width: "100%",
        arrows: false,
        pagination: false,
        drag: true,
        perPage: 3,
    }).mount();
};

window.initOnboardingDateSplide = function() {
    new Splide("#splide-date", {
        type: 'slide',
        arrows: false,
        pagination: false,
        drag: true,
        fixedWidth: "6rem",
        padding: { right: '2rem' },
    }).mount();
};

window.initSplideNosotros = function() {
    new Splide("#splide-our-experience", {
        width: "100%",
        arrows: false,
        pagination: true,
        perPage: 4,
        destroy: true,
        breakpoints: {
            768: {
                perPage: 1,
                destroy: false,
            },
            1024: {
                perPage: 3,
                destroy: false,
            },
            1280: {
                perPage: 4,
                destroy: true,
            },
        },
        classes: {
            prev: "splide__arrow--prev",
            next: "splide__arrow--next",
            pagination:
                "splide__pagination bottom-5 splide-btnspag-our-experience",
        },
    }).mount();

    new Splide("#splide-press-room", {
        arrows: true,
        pagination: true,
        perPage: 3,
        destroy: true,
        breakpoints: {
            740: {
                perPage: 1,
                destroy: false,
                gap: "1rem",
            },
            1200: {
                perPage: 2,
                destroy: false,
            },
        },
        classes: {
            prev: "splide__arrow--prev -left-4 hidden md:block",
            next: "splide__arrow--next -right-4 hidden md:block",
            pagination: "splide__pagination splide-btnspag-press-room",
        },
    }).mount();
};

window.initSplideServicioPro = function() {
    new Splide("#splide-betterLife", {
        width: "100%",
        height: "400px",
        arrows: false,
        pagination: true,
        perPage: 2,
        gap: "1em",
        breakpoints: {
            640: {
                perPage: 1,
                destroy: false,
            },
        },
        classes: {
            prev: "splide__arrow--prev",
            next: "splide__arrow--next",
            pagination: "splide__pagination splide-btnspag-betterLife",
        },
    }).mount();

    new Splide("#splide-comments", {
        width: "100%",
        height: "27rem",
        arrows: false,
        pagination: true,
        perPage: 3,
        gap: "4rem",
        destroy: true,
        breakpoints: {
            640: {
                perPage: 1,
            },
            1024: {
                perPage: 2,
            },
            1187: {
                perPage: 3,
                gap: "1rem",
                destroy: false,
            },
            1280: {
                perPage: 3,
                destroy: true,
            },
        },
        classes: {
            pagination: "splide__pagination slide-btnspag-comments",
        },
    }).mount();

    /* new Splide("#splide-communes", {
        height: 352,
        arrows: true,
        pagination: false,
        perPage: 4,
        gap: "1em",
        breakpoints: {
            640: {
                perPage: 1,
                fixedWidth: "100%",
                destroy: false,
                arrows: false,
            },
            1024: {
                perPage: 3,
                fixedWidth: "40%",
                destroy: false,
            },
            1280: {
                perPage: 4,
                destroy: false,
            },
        },
        classes: {
            arrows: "splide__arrows arrows-building-ext",
            arrow: "splide__arrow arrow-building-ext",
            prev: "splide__arrow--prev arrow-prev-building-ext",
            next: "splide__arrow--next arrow-next-building-ext",
        },
    }).mount(); */
};

window.initSplideProyectosMultifamily = () => {
    new Splide("#splide-our-experience", {
        width: "100%",
        arrows: false,
        pagination: true,
        perPage: 4,
        destroy: true,
        breakpoints: {
            768: {
                perPage: 1,
                destroy: false,
            },
            1024: {
                perPage: 3,
                destroy: false,
            },
            1280: {
                perPage: 4,
                destroy: true,
            },
        },
        classes: {
            prev: "splide__arrow--prev",
            next: "splide__arrow--next",
            pagination:
                "splide__pagination bottom-5 splide-btnspag-our-experience",
        },
    }).mount();
};

window.initSplideBuilding = function() {
    new Splide("#splide-carousel-building", {
        width: "100%",
        height: "380px",
        arrows: false,
        pagination: true,
        perPage: 1,
        breakpoints: {
            640: {
                height: "302px",
                perPage: 1,
                destroy: false,
            },
        },
    }).mount();

    new Splide("#splide-available-building", {
        width: "100%",
        height: "174px",
        arrows: false,
        pagination: true,
        perPage: 1,
        breakpoints: {
            640: {
                height: "250px",
                perPage: 1,
                destroy: false,
            },
        },
    }).mount();
};

window.initSplideGallery = function() {
    return new Splide("#splide-carousel-gallery", {
        width: "100%",
        type: "loop",
        arrows: true,
        gap: "1em",
        pagination: true,
        perPage: 1,
        classes: {
            arrows: "splide__arrows arrows-gallery",
            arrow: "splide__arrow arrow-gallery",
            prev: "splide__arrow--prev arrow-prev-gallery",
            next: "splide__arrow--next arrow-next-gallery",
        },
    }).mount();
};

window.initSplidePrensa = () => {
    new Splide("#splide-press", {
        height: "530px",
        arrows: false,
        pagination: true,
        perPage: 3,
        gap: "1.5em",
        breakpoints: {
            740: {
                perPage: 1,
                destroy: false,
            },
            1200: {
                perPage: 2,
                destroy: false,
            },
        },
        classes: {
            pagination: "splide__pagination splide-btnsprensa",
        },
    }).mount();
};

window.initSplideOwner = () => {
    // new Splide("#splide-testimony", {
    //     height: "19.5rem",
    //     arrows: false,
    //     pagination: true,
    //     perPage: 3,
    //     gap: "1.5em",
    //     destroy: true,
    //     breakpoints: {
    //         740: {
    //             perPage: 1,
    //         },
    //         1200: {
    //             perPage: 2,
    //             destroy: false,
    //         },
    //     },
    //     classes: {
    //         prev: "splide__arrow--prev",
    //         next: "splide__arrow--next",
    //         pagination: "splide__pagination splide-btnspag-comments",
    //     },
    // }).mount();

    const splide_press_room = document.querySelector('#splide-press-room')
    if (splide_press_room) {
        new Splide("#splide-press-room", {
            arrows: true,
            pagination: true,
            perPage: 1,
            destroy: true,
            breakpoints: {
                740: {
                    perPage: 1,
                    destroy: false,
                    gap: "1rem",
                },
                1200: {
                    perPage: 2,
                    destroy: false,
                    pagination: true,
                },
            },
            classes: {
                prev: "splide__arrow--prev",
                next: "splide__arrow--next",
                pagination: "splide__pagination splide-btnspag-press-room",
            },
        }).mount();
    }

    const splide_partner = document.querySelector('#splide-partner');
    if (splide_partner) {
        new Splide("#splide-partner", {
            arrows: false,
            pagination: false,
            perPage: 6,
            type: "loop",
            autoplay: true,
            gap: "1.5em",
            resetProgress: false,
            pauseOnHover: true,
            breakpoints: {
                740: {
                    perPage: 2,
                },
                1200: {
                    perPage: 4,
                },
            },
        }).mount();
    }
};

window.initSplideNotableBuilding = function(outerSliderElement){
    new Splide(outerSliderElement, {
        rewind: true,
        autoplay: 'pause',
        pagination:false,
        perPage:'1',
        height: 'auto', // height del li
        fixedHeight: true, // Opcional: fija la altura
        width:'100%',
        gap:'2rem',
        padding: 5,
        pauseOnHover:true,
        pauseOnFocus:true,
        breakpoints: {
            1020: {
                width:'100%',
                perPage:'2',
                pagination:true,
                height: '965px',
                padding: 2,
            },
            640:{
                perPage:'1',
                width:400,
            }
        }
    }).mount();

    const elms = document.getElementsByClassName("inner-slider");
    for (let i = 0, len = elms.length; i < len; i++) {
        if (elms[i].id.search("inner-slider") === -1) {

            new Splide(elms[i], {
                perPage:'1',
                arrows:true,
                rewind: true,
                autoplay: 'pause',
                height: 453, // height del li
                fixedHeight: true, // Opcional: fija la altura
                width:668,
                gap:'1rem',
                pagination:true,
                drag:false,
                speed:1000,
                breakpoints: {
                    1020: {
                        height: '100%',// height del li
                        width:'100%',
                        perPage:'1',

                    },
                    640:{
                        pagination:false,
                        perPage:'1',
                    }
                }
            }).mount();
        }
    }

}

window.initSplideHomeAssetplan = function() {
     
    document.querySelectorAll('.splide').forEach(el => {
        new Splide(el).mount();
    });
    
    // new Splide('#carousel-header-home', {
    //     arrows: false,
    //     rewind: true,
    //     autoplay: true,
    //     height: 500,
    //     fixedHeight: true,
    //     breakpoints: {
    //         640: {
    //             height: 460
    //         },
    //     }
    // }).mount();

    // new Splide('#carousel-experiencias-home', {
    //     arrows: false,
    //     pagination:false,
    //     autoplay: true,
    //     destroy:true,
    //     height: 460,
    //     width:'100%',
    //     fixedHeight: true,
    //     gap:'1rem',
    //     perPage: 3,
    //     breakpoints: {
    //         1024: {
    //             destroy:false,
    //             height: '690px',
    //             perPage:2,
    //         },
    //         768:{
    //             perPage: 2,
    //             height: '530px'
    //         },
    //         640:{
    //             perPage:1,
    //             height: '580px'
    //         },
    //     }
    // }).mount();

    // new Splide('#carousel-nosotros', {
    //     perPage:'3',
    //     height: 345, // height del li
    //     fixedHeight: true, // Opcional: fija la altura
    //     width:'100%',
    //     gap:'1rem',
    //     pagination:true,
    //     arrows:false,
    //     drag: true,
    //     destroy:true,
    //     breakpoints: {
    //         1200: {
    //             perPage:1,
    //             width:'90%',
    //             destroy:false
    //         },

    //     }
    // }).mount();
};

window.initCarouselExperiencias = function() {
    new Splide('#carousel-experiencias-home', {
        arrows: false,
        pagination:false,
        autoplay: true,
        destroy:true,
        height: 460,
        width:'100%',
        fixedHeight: true,
        gap:'1rem',
        perPage: 3,
        breakpoints: {
            1024: {
                destroy:false,
                height: '690px',
                perPage:2,
            },
            768:{
                perPage: 2,
                height: '530px'
            },
            640:{
                perPage:1,
                height: '580px'
            },
        }
    }).mount();
};



window.initCarouselOurHistory = function() {
    new Splide("#splide-our-history", {
        arrows: true,
        pagination: true,
        perPage: 4,
        destroy: false,
        width:'100%',
        height: '200px',
        fixedHeight: true,
        breakpoints: {
            1280: {
                perPage: 4,
                destroy: false,
            },
            1024: {
                destroy:false,
                perPage:4,
            },
            768:{
                perPage: 2,
            },
            640:{
                perPage:1,
            },
        },
        classes: {
            prev: "splide__arrow--prev -left-0  md:block",
            next: "splide__arrow--next -right-0  md:block",
            pagination: "splide__pagination splide-btnspag-press-room",
        },
    }).mount();

};

window.sendEvents = function(name, payload = {}) {
    if (typeof _kmq !== 'undefined') {
        _kmq.push(['record', name, payload]);
    }
};


window.csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
